import { queryOptions } from '@tanstack/react-query'
import getClientMe from '../api/get-client-me'

export const CLIENT_ME_QUERY_KEY = ['client-me'] as const

export const clientMeQueryOptions = queryOptions({
  queryKey: CLIENT_ME_QUERY_KEY,
  queryFn: getClientMe,
  staleTime: Infinity,
})
